var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('guard',{attrs:{"if-admin":_vm.guardFuncionalities}},[_c('is-loading',{attrs:{"if":_vm.isLoading,"centered":true}},[_c('has-request-error',{attrs:{"has-error":_vm.requestError,"is-loading":_vm.isReloading},on:{"retry":_vm.reloadData}},[_c('multilevel-sortable-list',{attrs:{"scope":"select","initial-data":_vm.sortableData,"is-category-selectable":true,"sortable-item-name":_vm.$t(
            _vm.isOption
              ? '_.product_options'
              : _vm.isAttribute
              ? '_.product_attributes'
              : '_.products'
          ),"item-name":_vm.$t(
            _vm.isOption
              ? '_.product_option'
              : _vm.isAttribute
              ? '_.product_attribute'
              : '_.product'
          ),"type":_vm.isOption
            ? 'product_options'
            : _vm.isAttribute
            ? 'product_attributes'
            : 'products',"is-selectable":true,"multiple-select":_vm.multipleSelect,"show-category-items":false},on:{"selectElement":_vm.selectElement}},[_c('template',{slot:"empty"},[(_vm.$slots.empty)?_vm._t("empty"):_c('no-results',{attrs:{"icon":"exclamation-circle","title":_vm.emptyResultsTitle,"message":_vm.emptyResultsMessage}})],2)],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }